import audio from '../../../../assets/audio/kids-tracks/Text26.mp3';
import cross from '../../../../assets/images/games/zdar-kids-game/cross.webp';
import final from '../../../../assets/images/games/zdar-kids-game/final.webp';

export const step35tree = {
    id: 35,
    title: 'Strom',
    taskText: `
        <p>
            Další duch a tenhle vypadá hodně zajímavě. Celý tak nějak svítí. 
        </p>
        <p>
            Kdo jsi, tajemný duchu? Nemůžeš nám říct, proč se to tu jmenuje Zelená hora? Zatím jsme se dozvěděli, že každý má 
            nějaký nápad, ale nikdo vlastně doopravdy neví jak to je.
        </p>
        <p>    
            Tak to budeš koukat. Prý je svatý a jmenuje se Jan Nepomucký. To po něm je ten kostel pojmenovaný. 
            Nepomuk se narodil na Zelené hoře, a proto tuhle horu na jeho počest opat Vejmluva pojmenoval stejně. 
        </p>
        <p>
            Ty jo, tak to jsem nečekal, proč nám to opat Vejmluva neřekl sám?
        </p>
        <p>
            No asi už to za ty roky zapomněl. 
        </p>
        <p>
            No nevadí, já i ty si to od teď už budeme pamatovat i za něj! Tak moc děkujeme pane duchu Nepomuku. 
        </p>
        <p>
            Jsem rád, že jsme na to přišli, jsi skvělý detektiv, děkuju za pomoc. Už bylo ale dost přemýšlení, 
            co kdybychom si šli teď hrát na to nedaleké hřiště? Schválně, kdo tam bude první!
        </p>
    `,
    cipher: {
        images: [cross, final],
    },
    continueButtonText: 'Ukončit hru',
    points: false,
    audio: audio,
};
